import { render, staticRenderFns } from "./QuestionList.vue?vue&type=template&id=dd50072e"
import script from "./QuestionList.vue?vue&type=script&lang=js"
export * from "./QuestionList.vue?vue&type=script&lang=js"
import style0 from "./QuestionList.vue?vue&type=style&index=0&id=dd50072e&prod&lang=scss"
import style1 from "./QuestionList.vue?vue&type=style&index=1&id=dd50072e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports